// extracted by mini-css-extract-plugin
export var storyRowWrapperCenter = "t_s2 d_bD";
export var storyRowWrapper = "t_hx d_hx d_bK";
export var storyLeftWrapper = "t_s3 d_bz d_bP";
export var storyWrapperFull = "t_s4 d_cD";
export var storyWrapperFullLeft = "t_pl d_cD d_bz d_bP d_bD";
export var contentWrapper = "t_mS d_hy";
export var storyLeftWrapperCenter = "t_s5 d_hz d_bz d_bD d_bP d_bJ";
export var storyRightWrapperCenter = "t_s6 d_hF";
export var storyHeader = "t_s7 d_hD d_w d_cs";
export var storyHeaderCenter = "t_hC d_hC d_w d_cs d_dw d_by";
export var storyParagraphCenter = "t_hB d_hB d_by d_dw";
export var storyBtnWrapper = "t_s8 d_d2 d_d1 d_w d_bz d_bG";
export var storyBtnWrapperCenter = "t_hJ d_hJ d_d1 d_w d_bz d_bD";
export var imageWrapper = "t_s9 d_fg d_Z";
export var imageWrapperFull = "t_tb d_w d_H d_bf d_Z";
export var SubtitleSmall = "t_qd q_qd q_qV q_q5";
export var SubtitleNormal = "t_qf q_qf q_qV q_q6";
export var SubtitleLarge = "t_qg q_qg q_qV q_q7";
export var textLeft = "t_dv";
export var textCenter = "t_dw";
export var textRight = "t_dx";